<script>
  export let content = '';
  export let idUnico = 'parafixar';
</script>

<div class="container">
  <div class="icon-wrapper">
    <svg width="39" height="43" viewBox="0 0 39 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_554_119"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="39"
        height="43"
      >
        <path
          d="M0 22.92C0 34.84 6.49 42.52 12.33 42.52C22.46 42.52 22.12 32.04 30.83 28.89C41.37 25.07 44.14 0 21.42 0C7.79 0 0 11 0 22.92Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_554_119)">
        <path d="M44.14 0H0V42.52H44.14V0Z" fill="url(#paint0_linear_554_119)" />
      </g>
      <path
        d="M33.8569 12.7801C34.7669 13.6901 34.8069 15.1601 33.9369 16.1101L23.7769 27.2701C23.6769 27.3801 23.5369 27.4401 23.3969 27.4401C23.2469 27.4401 23.1069 27.3901 23.0069 27.2801L14.7069 18.9801C14.6069 18.8701 14.5469 18.7301 14.5469 18.5901C14.5469 18.4401 14.6169 18.3001 14.7269 18.2101L25.8869 8.05013C26.8369 7.18013 28.3069 7.22013 29.2169 8.13013L33.8569 12.7701V12.7801Z"
        fill="white"
      />
      <path
        d="M22.6234 26.9212L15.0834 19.3812C14.7634 19.7012 14.3134 20.1512 13.9734 20.4912C13.8834 20.5812 13.8734 20.7112 13.9334 20.8212C14.5934 21.8612 14.8434 22.9013 14.6834 23.9313C14.5534 24.8013 14.1234 25.6813 13.3734 26.5413L15.4634 28.6312C16.3234 27.8712 17.2034 27.4512 18.0734 27.3212C19.1034 27.1712 20.1434 27.4212 21.1834 28.0812C21.2834 28.1512 21.4234 28.1313 21.5134 28.0413L22.6234 26.9313V26.9212ZM23.7534 27.3012L22.2634 28.7913C21.8234 29.2313 21.1334 29.3112 20.6034 28.9812C19.8034 28.4812 19.0134 28.2612 18.2234 28.3812C17.4134 28.5012 16.6234 28.9612 15.8234 29.7612C15.6134 29.9712 15.2734 29.9712 15.0634 29.7612L12.2434 26.9412C12.0334 26.7312 12.0334 26.3913 12.2434 26.1813C13.0334 25.3813 13.4934 24.5912 13.6234 23.7812C13.7434 22.9912 13.5234 22.2013 13.0234 21.4013C12.6934 20.8713 12.7734 20.1812 13.2134 19.7412C13.7934 19.1612 14.7034 18.2512 14.7034 18.2512C14.9134 18.0413 15.2534 18.0413 15.4634 18.2512L23.7634 26.5512C23.9734 26.7612 23.9734 27.1012 23.7634 27.3112L23.7534 27.3012Z"
        fill="white"
      />
      <path
        d="M10.3241 29.2691L12.8341 26.7591C13.0441 26.5491 13.3841 26.5491 13.5941 26.7591L15.2441 28.4091C15.4541 28.6191 15.4541 28.9591 15.2441 29.1691L14.3741 30.0391C14.2741 30.1391 14.1341 30.1991 13.9941 30.1991H10.7041C10.4841 30.1991 10.2941 30.0691 10.2041 29.8691C10.1241 29.6691 10.1641 29.4391 10.3241 29.2791V29.2691Z"
        fill="white"
      />
      <path
        d="M8.72344 30.2994H4.37344C3.90344 30.2994 3.52344 29.9194 3.52344 29.4594C3.52344 28.9994 3.90344 28.6094 4.37344 28.6094H8.72344C9.19344 28.6094 9.56344 28.9894 9.56344 29.4594C9.56344 29.9294 9.18344 30.2994 8.72344 30.2994Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_554_119"
          x1="-1.4103"
          y1="21.6214"
          x2="37.3197"
          y2="21.6214"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#4DB4AA" />
          <stop offset="1" stop-color="#E1DE21" />
        </linearGradient>
      </defs>
    </svg>
  </div>
  <div class="titulo">
    <h2>PARA <b>FIXAR</b></h2>
  </div>
  <div class="box-texto">
    {@html content}
  </div>
</div>

<style>
  .container {
    --Principais-Roxo-azul: #8421e9;
    --transparentes-roxo-10: rgba(132, 33, 233, 0.1);
    --cor-primaria: #b62ca2;
    --cor-secundaria: #33cfb9;

    position: relative;
    padding-top: 16px;
  }

  .icon-wrapper {
    position: absolute;
    top: 0;
    left: -20px;
    z-index: 10;
  }

  .icon-wrapper svg {
    width: 65px;
    height: auto;
    filter: drop-shadow(0 0 3px #00000044);
  }

  .box-texto :global(b) {
    display: block;
    margin-bottom: 1rem;
    color: var(--MARROM);
    font-size: 20px;
  }

  .box-texto {
    width: 100%;
    height: auto;

    color: #000000;
    font-family: var(--FONT_LORA);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 26px;

    border-radius: 0 35px 35px 35px;
    padding: 25px 30px 25px 29px;
    white-space: pre-wrap;
    word-break: break-word;

    border: 2px solid var(--VERDE_CLARO);
    background-color: #f9f8d3;

    background-origin: border-box;
    background-clip: padding-box, border-box;
  }
  .titulo {
    width: fit-content;
    background: linear-gradient(90deg, var(--VERDE_CLARO), var(--AMARELO));
    padding: 6px 15px 5px 60px;
    border-radius: 12.7px 20px 20px 0px;
  }

  .titulo h2 {
    color: var(--Principais-Branco, #fff);
    font-family: var(--FONT_ARCHI);
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: 0em;
  }

  @media (max-width: 800px) {
    .icon-wrapper {
      top: 5px;
      transform: translateY(0px);
      left: 10px;
    }

    .icon-wrapper svg {
      width: 55px;
      height: auto;
      filter: drop-shadow(0 0 3px #00000044);
    }
    .titulo {
      padding: 7px 25px 6px 60px;
      border-radius: 28px 20px 20px 0px;
      top: 18px;
      position: relative;
    }
    .box-texto {
      padding: 20px 20px 15px 20px;
      margin-top: 18px;
    }
  }
</style>
